import { Stack, Typography } from "@mui/material";
import { UnstyledLink } from "Components/Routes/UnstyledLink";
import { BanksList } from "Components/Shared/BanksList/BanksList";
import { InfoBox } from "Components/Shared/InfoBox/InfoBox";
import { useBankingAuth } from "Hooks/useBankingAuth";
import type { BankEnvironment } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";
import { appUrl } from "Utils/UrlUtils";
import OpenInNewOutlinedIcon from "@mui/icons-material/OpenInNewOutlined";

const RESOURCES = Resources.Customer.Pay;
const ANONYMOUS_RESOURCED =
  Resources.Pages.Content.CustomerAnonymousPaymentPay.BankSelection;

type Props = {
  transactionPublicID: string;
  onError?: () => void;
};

export const BankSelector = ({ transactionPublicID }: Props) => {
  const { isPending, authorize, selectedEnvironment } = useBankingAuth();
  const { t } = useResource();

  const onBankSelected = (environment: BankEnvironment) => {
    if (!isPending) {
      authorize({ environment, transactionPublicID });
    }
  };

  return (
    <Stack gap={4}>
      <Typography>{t(RESOURCES.ChooseBank)}</Typography>
      <Stack gap={2}>
        <InfoBox variant="info" content={t(ANONYMOUS_RESOURCED.InfoBox)} />
        <InfoBox
          variant="warning"
          content={t(ANONYMOUS_RESOURCED.WarningBox)}
        />
      </Stack>
      <BanksList
        actionType="select"
        onSelect={onBankSelected}
        pendingEnvironment={isPending ? selectedEnvironment : undefined}
        bankFilter="enabledOnly"
      />
      <UnstyledLink to={appUrl("bank-connection-ranking")}>
        <Typography
          display="flex"
          gap={1}
          alignItems="center"
          justifyContent="center"
        >
          <OpenInNewOutlinedIcon sx={{ fontSize: "0.9rem" }} />
          {t(Resources.BankRating.Title)}
        </Typography>
      </UnstyledLink>
    </Stack>
  );
};
